import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

export type DetailsOptions = {
  keySummary?: string;
  keysExcluded?: Record<string, unknown>;
  captainOnly?: boolean;
  summaryOnly?: boolean;
};

export type RefereeContextType = {
  isRefereeView: boolean;
  setIsRefereeView: Dispatch<SetStateAction<boolean>>;
  gameId?: string;
  detailsOptions?: DetailsOptions;
  setDetailsOptions?: Dispatch<SetStateAction<DetailsOptions | undefined>>;
  isUpdating: boolean;
  setIsUpdating: Dispatch<SetStateAction<boolean>>;
};

const defaultState: RefereeContextType = {
  isRefereeView: false,
  setIsRefereeView: () => {
    /* */
  },
  isUpdating: false,
  setIsUpdating: () => {
    /* */
  },
};

const RefereeContext = createContext(defaultState);

export function useReferee() {
  const context = useContext(RefereeContext);
  if (!context) {
    throw new Error('useReferee must be used within a RefereeProvider');
  }
  return useContext(RefereeContext);
}

export type RefereeProviderProps = {
  children: ReactNode;
  gameId: string;
};

export function RefereeProvider({ children, gameId }: RefereeProviderProps) {
  const [isRefereeView, setIsRefereeView] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [detailsOptions, setDetailsOptions] = useState<
    Record<string, unknown> | undefined
  >(undefined);
  return (
    <RefereeContext.Provider
      value={{
        gameId,
        isRefereeView,
        setIsRefereeView,
        detailsOptions,
        setDetailsOptions,
        isUpdating,
        setIsUpdating,
      }}
    >
      {children}
    </RefereeContext.Provider>
  );
}
